export const skeletonAnimationStyles = `
  @keyframes pulse {
    0% { opacity: 0.3; }
    50% { opacity: 0.8; }
    100% { opacity: 0.3; }
  }
  .skeleton-pulse-active {
    animation: pulse 1.5s ease-in-out infinite;
  }
`

export const counterSkeletonStyles = {
  getContainerStyle: (originalContainerStyles) => ({
    ...originalContainerStyles,
  }),

  skeletonBoxFallback: {
    width: '100%',
    maxWidth: '1460px',
    height: '70px',
    backgroundColor: 'rgba(0, 65, 101, 0.1)',
    borderRadius: '8px',
  },

  counterWrapper: {
    display: 'inline-block', 
  },
}